<template>
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <g clip-path="url(#clip0_6443_56968)">
    <path d="M18.3327 9.99935C18.3327 14.6017 14.6017 18.3327 9.99935 18.3327M18.3327 9.99935C18.3327 5.39698 14.6017 1.66602 9.99935 1.66602M18.3327 9.99935H1.66602M9.99935 18.3327C5.39698 18.3327 1.66602 14.6017 1.66602 9.99935M9.99935 18.3327C7.85954 16.0859 6.66602 13.1021 6.66602 9.99935C6.66602 6.89663 7.85954 3.91281 9.99935 1.66602M9.99935 18.3327C12.1392 16.0859 13.3327 13.1021 13.3327 9.99935C13.3327 6.89663 12.1392 3.91281 9.99935 1.66602M1.66602 9.99935C1.66602 5.39698 5.39698 1.66602 9.99935 1.66602" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
  <defs>
    <clipPath id="clip0_6443_56968">
      <rect width="20" height="20" fill="white"/>
    </clipPath>
  </defs>
</svg>
</template>